import { create } from 'zustand';
import type { FeatureFlags } from '@/hooks/useFeatureFlags';

export interface FeatureFlagsState {
  featureFlags: FeatureFlags;
  setFeatureFlags: (flags: FeatureFlags) => void;
}

const useFeatureFlagsStore = create<FeatureFlagsState>((set) => ({
  featureFlags: {
    relevanceSearch: false,
    inBranchAppointments: false,
  },
  setFeatureFlags: (flags) => set({ featureFlags: flags }),
}));

export default useFeatureFlagsStore;
